export default __webpack_public_path__ + "static/media/regulatory--turn-left--g1.12ef941b.png";